import React from 'react';

export const ActionGunIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M65.25 75.8124H50.9375C48.7813 75.8124 46.8125 74.5311 45.9688 72.5311L41.0312 60.7811L43.8437 59.5936L48.7812 71.3436C49.1562 72.2186 49.9688 72.7811 50.9063 72.7811H65.2188V75.8124H65.25Z"
        fill="#321B41"
      />
      <path
        d="M91.4062 39.8438H87.5V50.7812H91.4062C92.7007 50.7812 93.75 49.7319 93.75 48.4375V42.1875C93.75 40.8931 92.7007 39.8438 91.4062 39.8438Z"
        fill="#9B9B9B"
      />
      <path
        d="M6.25 45.3125C6.25 43.5866 7.64911 42.1875 9.375 42.1875H18.75V48.4375H9.375C7.64911 48.4375 6.25 47.0384 6.25 45.3125Z"
        fill="#9B9B9B"
      />
      <path
        d="M57.6249 60.8127H32.0311C29.1874 60.8127 26.8749 58.5002 26.8436 55.6564H82.3749C82.0311 55.7814 81.7499 56.0939 81.6874 56.4689C81.3749 58.3752 80.0311 59.9377 78.2499 60.5314C77.8124 60.6564 77.5936 61.0939 77.6874 61.5314L82.7186 79.6564C84.3436 85.4689 79.9686 91.2189 73.9374 91.2189C69.8436 91.2189 66.2499 88.4689 65.1561 84.5314L58.8124 61.7189C58.6561 61.1877 58.1874 60.8127 57.6249 60.8127Z"
        fill="#9B9B9B"
      />
      <path
        d="M54.5312 64.2186C54.5312 63.1561 53.6874 62.3123 52.6249 62.3123C51.5624 62.3123 50.7187 63.1873 50.7187 64.2498V69.4998C50.7187 70.5623 51.5624 71.4061 52.6249 71.4061C53.6874 71.4061 54.5312 70.5623 54.5312 69.4998V68.1763L55.6519 66.9312L54.5312 65.5518V64.2186Z"
        fill="#9B9B9B"
      />
      <path
        d="M23.4375 34.375C17.3969 34.375 12.5 39.2719 12.5 45.3125C12.5 51.3531 17.3969 56.25 23.4375 56.25H82.8125C86.2643 56.25 89.0625 53.4518 89.0625 50V40.625C89.0625 37.1732 86.2643 34.375 82.8125 34.375H23.4375Z"
        fill="#5A5A5A"
      />
      <path d="M60.6112 68.1874L59.8725 65.5312H54.5311V68.1874H60.6112Z" fill="#5A5A5A" />
    </svg>
  );
};
